import moment from "moment";
import { notification } from "tea-component";
import { getDateWeekDayStr } from "./utils";

const accumulateKeyArr: string[] = ['region', 'country', 'zone', 'system', 'channel', 'language', 'bundle', 'bundle_name',
  'region_name', 'country_name', 'zone_name', 'system_name', 'channel_name', 'language_name', 'lang',
  'lang_name', 'app_version', 'network_type', 'store_channel', 'app_version_name', 'memory', 'network_type_name',
  'memory_name', 'store_channel_name', 'by_region', 'by_channel', 'by_system', 'by_country', 'by_country', 'by_language',
  'by_lang', 'by_network', 'product', 'category', 'version', 'churn_level', 'by_churn_level', 'event_type', 'event',
  'title', 'price', 'wow_top_modid', 'wow_top_modname', 'wow_top_uid', 'wow_top_vrolename','game_stage_name', 'character_class_name', 'user_type_name'];
const accumulateKeyObj: any = {
  region: 'region_name',
  country: 'country_name',
  zone: 'zone_name',
  system: 'system_name',
  channel: 'channel_name',
  language: 'language_name',
  bundle: 'bundle_name',
  os: 'system_name', // 兜底处理
  lang: 'language_name', // 兜底处理
  product: 'product',
  category: 'category',
  version: 'game_name',
  churn_level: 'churn_level_name',
  event: 'event_name',
  event_type: 'event_type_name'
  // event_type:''
  // appVersion:'app_version',
  // networkType:'network',
  // memory:'memory',
  // storeChannel:'store_channel'
};

const dodKeyObj: any = {
  day: 'dod',
  week: 'wow',
  month: 'mom'
};

const sdlwKeyObj: any = {
  day: 'sdlw',
  week: 'swlm',
  month: 'smly'
};

export const handleTableCopyColumns = (props: any) => {
  const { type, key, columns, records, selectType, timeType, formatMessage, colName, isHeatMapTable, isHaveWeek = true } = props;
  const isMonth = timeType?.toLowerCase() === 'month';
  const isHaveWeekCol = !isMonth && isHaveWeek;
  // 表格中默认值为'',所以这里加个默认值'value_only'
  const selectTypeVal = selectType ? selectType : 'value_only';
  const isDod = isHeatMapTable ? records?.[0]?.[key].dod : '';
  const columnsData = columns?.filter((item: { copyKey: string; key: string; }) => item.copyKey ? item.copyKey === key : item.key === key)?.[0] || {};
  const header = columnsData?.header?.props?.value || columnsData?.header || '-';
  const headerHaveObj = {
    hideCopyDod: columnsData?.copyConfig?.hideCopyDod || false,
    hideCopySdlw: columnsData?.copyConfig?.hideCopySdlw || false,
    hideCopyChange: columnsData?.copyConfig?.hideCopyChange || false,
  };
  const DOD_STR = !headerHaveObj.hideCopyDod ? `\t${  formatMessage({ id: dodKeyObj?.[timeType?.toLowerCase()] })  }\n` : '\n';
  const CHANGE_STR = !headerHaveObj.hideCopyChange ? `\t${  formatMessage({ id: 'change' })  }\n` : '\n';
  const SDLW_STR = !headerHaveObj.hideCopySdlw ? `\t${  formatMessage({ id: sdlwKeyObj?.[timeType?.toLowerCase()] })  }\n` : '\n';
  let HEADER_STR = '';
  if (isHeatMapTable) {
    HEADER_STR = isDod ? (`${colName || '-'  }\t${  formatMessage({ id: dodKeyObj?.[timeType?.toLowerCase()] })  }\n`) : `${colName || '-'  }\n`;
  } else {
    HEADER_STR = `${header  }\n`;
  }
  HEADER_STR = HEADER_STR;

  const DATE_STR = !isHaveWeekCol ? `${formatMessage({ id: 'date' })  }\t` : `${formatMessage({ id: 'date' })  }\t${  formatMessage({ id: 'common_day_of_week' })  }\t`;
  const DATE_HEADER_STR = !isHaveWeekCol ? `${formatMessage({ id: 'date' })  }\n` : `${formatMessage({ id: 'date' })  }\t${  formatMessage({ id: 'common_day_of_week' })  }\n`;
  const TIME_HEADER_STR =  formatMessage({ id: 'common_time' });
  const DATE_CONTRST_HEADER_STR = !isHaveWeekCol ? `${formatMessage({ id: 'comparison_analysis_date_comparison_contrast_date' })  }\n` : `${formatMessage({ id: 'comparison_analysis_date_comparison_contrast_date' })  }\t${  formatMessage({ id: 'common_day_of_week' })  }\n`;
  if (type === 'date') {
    const content = isHeatMapTable ? getHeatMapDateContent(DATE_HEADER_STR, records, formatMessage, isHaveWeekCol) : getDateContent(DATE_HEADER_STR, records, formatMessage, isMonth, isHaveWeekCol);
    const flag = copyText(content);
    notification.success({
      description: flag ? formatMessage({ id: 'common_copy_success' }) : formatMessage({ id: 'common_copy_fail' }),
      className: 'filter-lock-alert',
      duration: 1000
    });
  }
  if (type === 'time') {
    const content = getTimeContent(TIME_HEADER_STR, records, formatMessage);
    const flag = copyText(content);
    notification.success({
      description: flag ? formatMessage({ id: 'common_copy_success' }) : formatMessage({ id: 'common_copy_fail' }),
      className: 'filter-lock-alert',
      duration: 1000
    });
  }
  if (type === 'contrast_date') {
    const content = getContrastDateContent(DATE_CONTRST_HEADER_STR, records, formatMessage, isMonth, isHaveWeekCol);
    const flag = copyText(content);
    notification.success({
      description: flag ? formatMessage({ id: 'common_copy_success' }) : formatMessage({ id: 'common_copy_fail' }),
      className: 'filter-lock-alert',
      duration: 1000
    });
  }

  if (type === 'current') {
    const headerObj: any = {
      'dod': header + DOD_STR,
      'sdlw': header + SDLW_STR,
      'value_only': HEADER_STR,
      'change': header + CHANGE_STR,
    };
    const content = isHeatMapTable ? getHeatMapCurrentContent(headerObj, selectTypeVal, records, key, formatMessage, timeType) :
      getCurrentContent(headerObj, selectTypeVal, records, key, formatMessage, timeType, headerHaveObj);
    const flag = copyText(content);
    notification.success({
      description: flag ? formatMessage({ id: 'common_copy_success' }) : formatMessage({ id: 'common_copy_fail' }),
      className: 'filter-lock-alert',
      duration: 1000
    });
  }

  if (type === 'currentAndDate') {
    const headerObj: any = {
      'dod': DATE_STR + header + DOD_STR,
      'sdlw': DATE_STR + header + SDLW_STR,
      'value_only': DATE_STR + HEADER_STR,
      'change': header + CHANGE_STR,
    };
    const content = isHeatMapTable ? getHeatMapDateAndCurrentContent(headerObj, selectTypeVal, records, key, formatMessage, timeType) :
      getDateAndCurrentContent(headerObj, HEADER_STR, selectTypeVal, records, key, formatMessage, timeType, isHaveWeekCol, headerHaveObj);
    const flag = copyText(content);
    notification.success({
      description: flag ? formatMessage({ id: 'common_copy_success' }) : formatMessage({ id: 'common_copy_fail' }),
      className: 'filter-lock-alert',
      duration: 1000
    });
  }

  if (type === 'currentAndTime') {
    const content = getTimeAndCurrentContent(HEADER_STR, selectTypeVal, records, key, formatMessage, timeType, isHaveWeekCol, headerHaveObj);
    const flag = copyText(content);
    notification.success({
      description: flag ? formatMessage({ id: 'common_copy_success' }) : formatMessage({ id: 'common_copy_fail' }),
      className: 'filter-lock-alert',
      duration: 1000
    });
  }
};
// const { weekStr } = getDateWeekDayStr(dateItem, formatMessage);

const getContrastDateContent = (dateColunm: any, records: { date: any; }[], formatMessage: any, isMonth: boolean, isHaveWeekCol: boolean) => {
  let content = dateColunm;
  const dateCol = records?.map((item: { contrast_date: any; }) => item?.contrast_date || '-');
  for (let i = 0;i < dateCol?.length;i++) {
    const dateItem = dateCol[i];
    const isDateType = moment(dateItem).isValid();
    const isHaveWeekStr = dateItem?.includes('(');
    // 当前系统时间长度都是5，其他日期和月的长度都要大于5,也可以通过列操作传其他参数判断
    let dateColItem = '';
    if (isHaveWeekStr || !isDateType) {
      dateColItem = dateItem;
    } else if (isMonth) {
      dateColItem = moment(dateItem)?.format('YYYY-MM');
    } else if (isHaveWeekCol) {
      dateColItem = `${moment(dateItem)?.format('YYYY-MM-DD')  }(${  getDateWeekDayStr(dateItem, formatMessage)?.weekStr  })`;
    }
    const item = dateColItem?.split('(') || [];
    content += (isMonth || !isHaveWeekCol) ? `${dateColItem || '-'  }\n` : `${item?.[0] || '-'  }\t${  item?.[1]?.split(')')?.[0] || '-'  }\n`;

  }
  return content;
};


const getDateContent = (dateColunm: any, records: { date: any; }[], formatMessage: any, isMonth: boolean, isHaveWeekCol: boolean) => {
  let content = dateColunm;
  const dateCol = records?.map((item: { date: any; }) => item?.date || '-');
  const isTime = dateCol?.[0]?.length === 5 || dateCol?.[0]?.length === 16;
  content = isTime ? `${formatMessage({ id: 'common_time' })  }\n` : content;
  for (let i = 0;i < dateCol?.length;i++) {
    const dateItem = dateCol[i];
    const isDateType = moment(dateItem).isValid();
    const isNotSpitArr = dateItem?.includes(formatMessage({ id: 'common_Average(remove_Null)' })) || dateItem?.includes(formatMessage({ id: 'common_Average(remove_Null&0)' }));
    const isHaveWeekStr = dateItem?.includes('(');
    // 当前系统时间长度都是5，其他日期和月的长度都要大于5,也可以通过列操作传其他参数判断
    let dateColItem = (isHaveWeekStr && !isNotSpitArr) ? dateItem : (isMonth ? moment(dateItem)?.format('YYYY-MM') :
      isHaveWeekCol ? `${moment(dateItem)?.format('YYYY-MM-DD')  }(${  getDateWeekDayStr(dateItem, formatMessage)?.weekStr  })` : moment(dateItem)?.format('YYYY-MM-DD'));
    if (!isDateType) {
      dateColItem = dateItem;
    }
    const item = isNotSpitArr ? dateColItem : dateColItem?.split('(') || [];
    if (isTime) {
      content += `${dateCol[i] || '-'  }\n`;
    } else if (isNotSpitArr) {
      return content += isMonth ? `${dateColItem || '-'  }\n` : isHaveWeekCol ? `${dateColItem || '-'  }\t` + `-` + `\n` : `${dateColItem || '-'  }\n`;
    } else {
      content += (isMonth) ? `${dateColItem || '-'  }\n` :
        isHaveWeekCol ? `${item?.[0] || '-'  }\t${  item?.[1]?.split(')')?.[0] || '-'  }\n` : `${item?.[0] || '-'  }\n`;
    }
  }
  return content;
};

const getTimeContent = (dateColunm: any, records: { date: any; }[]) => {
  let content = dateColunm;
  
  const dateCol = records?.map((item: { date: any; }) => {
    const dateItem = item?.date;
    const formattedTime = moment(dateItem)?.format('HH:mm');

    return formattedTime;
  });

  content += `\n${  dateCol.join('\n')}`;

  return content;
};


const getHeatMapDateContent = (dateColunm: any, records: { date: any; }[], formatMessage: any, isHaveWeekCol: boolean) => {
  let content = dateColunm;
  const dateCol = records?.map((item: { date: any; }) => item?.date || '-');
  for (let i = 0;i < dateCol?.length;i++) {
    const dateItem = dateCol?.[i];
    const { weekStr } = getDateWeekDayStr(dateItem, formatMessage);
    content += !isHaveWeekCol ? `${dateItem || '-'  }\n` : `${dateItem || '-'  }\t${  weekStr || '-'  }\n`;
  }
  return content;
};

const getCurrentContent = (headerObj: any, selectType: string, records: any, key: string, formatMessage: ((arg0: { id: string; }) => any) | undefined, timeType: string, headerHaveObj: any) => {
  let content = headerObj?.[selectType];
  // 目前只有时间对比这里是展示变化率,迭代时间不够,先临时用formatMessage处理是否为change
  // const isChange = headerObj?.[selectType]?.includes(formatMessage({ id: 'change' }))
  if (accumulateKeyArr?.includes(key)) {
    content = removeDodSdlwChangeHeader(content, formatMessage, timeType);
    const accumulateData = records?.map((item: { [x: string]: any; }) => 
      // item?.dimensions?.[key]为versionDaily的游戏版本信息
      item?.[accumulateKeyObj[key]] || item?.[key]?.groupBy || item?.[`by_${key}`] || item?.[key] || item?.dimensions?.[accumulateKeyObj?.[key]]
    );
    for (let i = 0;i < accumulateData?.length;i++) {
      content += `${accumulateData[i] || '-'  }\n`;
    }
  } else {
    const isHaveMetrics = records?.[0]?.metrics;
    const metricsInit = isHaveMetrics ? (records?.map((item: { metrics: any; }) => item.metrics) || []) : records;
    const metricsData = metricsInit?.map((item: { [x: string]: any; }) => isHaveMetrics ? item?.[key] : {
      value: (item?.[key]?.value || item?.[key]?.value === '') ? item?.[key]?.value : item?.[key],
      // 后端有这种dod格式的数据，如ua,也有直接是对象的如：回流
      dodPercentStr: (item?.[key]?.dod || item?.[key]?.dod === '') ? item?.[key]?.dod : item?.[`${key}_dod`],
      change: (item?.[key]?.change || item?.[key]?.change === '') ? item?.[key]?.change : item?.[`${key}_change`],
      sdlwPercentStr: (item?.[key]?.sdlw || item?.[key]?.sdlw === '') ? item?.[key]?.sdlw : item?.[`${key}_dsdlw`],
    });
    for (let i = 0;i < metricsData?.length;i++) {
      const value = metricsData[i]?.value || '-';
      const dodPercentStr = (metricsData[i]?.dod || metricsData[i]?.dodPercentStr || '-');
      const sdlwPercentStr = (metricsData[i]?.sdlw || metricsData[i]?.sdlwPercentStr || '-');
      const change = metricsData[i]?.change || '-';
      if (selectType === 'dod' && !headerHaveObj.hideCopyDod) {
        content += `${value  }\t${  dodPercentStr  }\n`;
      } else if (selectType === 'change' && !headerHaveObj.hideCopyChange) {
        content += `${value  }\t${  change  }\n`;
      } else if (selectType === 'sdlw' && !headerHaveObj.hideCopySdlw) {
        content += `${value  }\t${  sdlwPercentStr  }\n`;
      } else {
        content += `${value  }\n`;
      }
    }
  }
  return content;
};

const getHeatMapCurrentContent = (headerObj: any, selectType: string, records: any, key: string, formatMessage: (arg0: { id: any; }) => string, timeType: string) => {
  let content = headerObj?.[selectType];
  if (accumulateKeyArr?.includes(key)) {
    content = removeDodSdlwChangeHeader(content, formatMessage, timeType);
    const accumulateData = records?.map((item: { [x: string]: any; }) => item?.[key]?.text || item?.[key]);
    for (let i = 0;i < accumulateData?.length;i++) {
      content += `${accumulateData[i] || '-'  }\n`;
    }
  } else {
    const metricsData = records?.map((item: { [x: string]: any; }) => item?.[key]);
    for (let i = 0;i < metricsData?.length;i++) {
      const item = metricsData[i];
      // item?.dod === '' 主要是为了有些时间列的非时间值（如avg、sum、加权留存）的时候dod存在但是为空
      if (item?.dod || item?.dod === '') {
        content += `${item?.count || item?.value || '-'  }\t${  item?.dod || '-'  }\n`;
      } else if (item?.bubble) {
        content += `${item?.cellContent || '-'  }\n`;
      } else {
        content += `${item || '-'  }\n`;
      }

    }
  }
  return content;
};

const getDateAndCurrentContent = (headerObj: any, HEADER_STR: string, selectType: string, records: any, key: string, formatMessage: any, timeType: string, isHaveWeekCol: boolean, headerHaveObj: any) => {
  const isTime = records?.[0]?.date?.length === 5 || records?.[0]?.date?.length === 16;
  const isMonth = timeType?.toLowerCase() === 'month';
  const dateCol = records?.map((item: { date: any; }) => {
    const dateItem = item?.date;
    const isNotSpitArr = dateItem?.includes(formatMessage({ id: 'common_Average(remove_Null)' })) || dateItem?.includes(formatMessage({ id: 'common_Average(remove_Null&0)' }));

    // return isMonth ? (item?.date || '-') : (dateItem?.[0] || '-') + '\t' + (dateItem?.[1]?.split(')')?.[0] || '-');
    const isDateType = moment(dateItem).isValid();
    const isHaveWeekStr = dateItem?.includes('(');
    let dateColItem = '';
    if (isHaveWeekStr && !isNotSpitArr) {
      dateColItem = dateItem;
    } else if (isMonth) {
      dateColItem = moment(dateItem)?.format('YYYY-MM');
    } else {
      if (isHaveWeekCol) {
        dateColItem = (`${moment(dateItem)?.format('YYYY-MM-DD')  }(${  getDateWeekDayStr(dateItem, formatMessage)?.weekStr  })`);
      } else {
        dateColItem = isDateType ? moment(dateItem)?.format('YYYY-MM-DD') : dateItem;
      }
    }
    // 其实只用!isDateType应该就可以,主要有日期和时间都存在的类型如 2021-06-26 06:00，此时isDateType为true无法判断
    if (isTime || !isDateType) {
      dateColItem = dateItem;
    }
    const itemArr = isNotSpitArr ? dateColItem : dateColItem?.split('(') || [];
    if (isNotSpitArr) {
      return isMonth ? (dateColItem || '-') : (isHaveWeekCol ? (`${dateColItem || '-'  }\t` + `-`) : (dateColItem || '-'));
    }
    return (isMonth || isTime) ? (dateColItem || '-') : (isHaveWeekCol ? (`${itemArr?.[0] || '-'  }\t${  itemArr?.[1]?.split(')')?.[0] || '-'}`) : (itemArr?.[0] || '-'));
  });
  let content = headerObj?.[selectType];
  content = isTime ? `${formatMessage({ id: 'common_time' })  }\t${  HEADER_STR}` : content;
  if (accumulateKeyArr?.includes(key)) {
    content = removeDodSdlwChangeHeader(content, formatMessage, timeType);
    const accumulateData = records?.map((item: { [x: string]: any; }) => item?.[accumulateKeyObj[key]] || item?.[key]?.groupBy || item?.[`by_${key}`] || item?.[key]);
    for (let i = 0;i < accumulateData?.length;i++) {
      content += `${dateCol[i] || '-'  }\t${  accumulateData[i] || '-'  }\n`;
    }
  } else {
    const isHaveMetrics = records?.[0]?.metrics;
    const metricsInit = isHaveMetrics ? (records?.map((item: { metrics: any; }) => item.metrics) || []) : records;
    const metricsData = metricsInit?.map((item: { [x: string]: any; }) => 
      // return isHaveMetrics ? item?.[key] : {
      //   value: item?.[key]?.value || item?.[key],
      //   // 后端有这种dod格式的数据，如ua,也有直接是对象的如：回流
      //   dodPercentStr: item?.[key]?.dod || item?.[`${key}_dod`],
      //   change: item?.[key]?.change || item?.[`${key}_change`],
      //   sdlwPercentStr: item?.[key]?.sdlw || item?.[`${key}_dsdlw`],
      // }
      isHaveMetrics ? item?.[key] : {
        value: (item?.[key]?.value || item?.[key]?.value === '') ? item?.[key]?.value : item?.[key],
        // 后端有这种dod格式的数据，如ua,也有直接是对象的如：回流
        dodPercentStr: (item?.[key]?.dod || item?.[key]?.dod === '') ? item?.[key]?.dod : item?.[`${key}_dod`],
        change: (item?.[key]?.change || item?.[key]?.change === '') ? item?.[key]?.change : item?.[`${key}_change`],
        sdlwPercentStr: (item?.[key]?.sdlw || item?.[key]?.sdlw === '') ? item?.[key]?.sdlw : item?.[`${key}_dsdlw`],
      }
    );
    for (let i = 0;i < metricsData?.length;i++) {
      const value = metricsData[i]?.value || '-';
      const change = metricsData[i]?.change || '-';
      const dodPercentStr = metricsData[i]?.dod || metricsData[i]?.dodPercentStr || '-';
      const sdlwPercentStr = (metricsData[i]?.sdlw || metricsData[i]?.sdlwPercentStr || '-');
      if (selectType === 'dod' && !headerHaveObj.hideCopyDod) {
        content += `${dateCol[i] || '-'  }\t${  value  }\t${  dodPercentStr  }\n`;
      } else if (selectType === 'sdlw' && !headerHaveObj.hideCopySdlw) {
        content += `${dateCol[i] || '-'  }\t${  value  }\t${  sdlwPercentStr  }\n`;
      } else if (selectType === 'change' && !headerHaveObj.hideCopyChange) {
        content += `${dateCol[i] || '-'  }\t${  value  }\t${  change  }\n`;
      } else {
        content += `${dateCol[i] || '-'  }\t${  value  }\n`;
      }
    }
  }
  return content;
};

const getTimeAndCurrentContent = (HEADER_STR: string, selectType: string, records: any, key: string, formatMessage: any, timeType: string, isHaveWeekCol: boolean, headerHaveObj: any) => {
  const dateCol = records?.map((item: { date: any; }) => {
    const dateItem = item?.date;
  
    const dateColItem = moment(dateItem)?.format('HH:mm');
    return dateColItem;
  });
  let content = '';
  content =  `${formatMessage({ id: 'common_time' })  }\t${  HEADER_STR}`; 
  if (accumulateKeyArr?.includes(key)) {
    content = removeDodSdlwChangeHeader(content, formatMessage, timeType);
    const accumulateData = records?.map((item: { [x: string]: any; }) => item?.[accumulateKeyObj[key]] || item?.[key]?.groupBy || item?.[`by_${key}`] || item?.[key]);
    for (let i = 0;i < accumulateData?.length;i++) {
      content += `${dateCol[i] || '-'  }\t${  accumulateData[i] || '-'  }\n`;
    }
  } else {
    const isHaveMetrics = records?.[0]?.metrics;
    const metricsInit = isHaveMetrics ? (records?.map((item: { metrics: any; }) => item.metrics) || []) : records;
    const metricsData = metricsInit?.map((item: { [x: string]: any; }) => 
      // return isHaveMetrics ? item?.[key] : {
      //   value: item?.[key]?.value || item?.[key],
      //   // 后端有这种dod格式的数据，如ua,也有直接是对象的如：回流
      //   dodPercentStr: item?.[key]?.dod || item?.[`${key}_dod`],
      //   change: item?.[key]?.change || item?.[`${key}_change`],
      //   sdlwPercentStr: item?.[key]?.sdlw || item?.[`${key}_dsdlw`],
      // }
      isHaveMetrics ? item?.[key] : {
        value: (item?.[key]?.value || item?.[key]?.value === '') ? item?.[key]?.value : item?.[key],
        // 后端有这种dod格式的数据，如ua,也有直接是对象的如：回流
        dodPercentStr: (item?.[key]?.dod || item?.[key]?.dod === '') ? item?.[key]?.dod : item?.[`${key}_dod`],
        change: (item?.[key]?.change || item?.[key]?.change === '') ? item?.[key]?.change : item?.[`${key}_change`],
        sdlwPercentStr: (item?.[key]?.sdlw || item?.[key]?.sdlw === '') ? item?.[key]?.sdlw : item?.[`${key}_dsdlw`],
      }
    );
    for (let i = 0;i < metricsData?.length;i++) {
      const value = metricsData[i]?.value || '-';
      const change = metricsData[i]?.change || '-';
      const dodPercentStr = metricsData[i]?.dod || metricsData[i]?.dodPercentStr || '-';
      const sdlwPercentStr = (metricsData[i]?.sdlw || metricsData[i]?.sdlwPercentStr || '-');
      if (selectType === 'dod' && !headerHaveObj.hideCopyDod) {
        content += `${dateCol[i] || '-'  }\t${  value  }\t${  dodPercentStr  }\n`;
      } else if (selectType === 'sdlw' && !headerHaveObj.hideCopySdlw) {
        content += `${dateCol[i] || '-'  }\t${  value  }\t${  sdlwPercentStr  }\n`;
      } else if (selectType === 'change' && !headerHaveObj.hideCopyChange) {
        content += `${dateCol[i] || '-'  }\t${  value  }\t${  change  }\n`;
      } else {
        content += `${dateCol[i] || '-'  }\t${  value  }\n`;
      }
    }
  }
  return content;
};

const getHeatMapDateAndCurrentContent = (headerObj: any, selectType: string, records: any, key: string, formatMessage: any, timeType: string) => {
  const dateCol = records?.map((item: { date: any; }) => {
    const dateItem = item?.date;
    const { weekStr } = getDateWeekDayStr(dateItem, formatMessage);
    return isMonth ? (dateItem || '-') : `${dateItem || '-'  }\t${  weekStr || '-'}`;
  });
  const isMonth = timeType?.toLowerCase() === 'month';
  let content = headerObj?.[selectType];
  if (accumulateKeyArr?.includes(key)) {
    content = removeDodSdlwChangeHeader(content, formatMessage, timeType);
    // 多时区，维度是用对象的{text:'',value:''}
    const accumulateData = records?.map((item: { [x: string]: any; }) => item?.[key]?.text || item?.[key]);
    for (let i = 0;i < accumulateData?.length;i++) {
      content += `${dateCol[i] || '-'  }\t${  accumulateData[i] || '-'  }\n`;
    }
  }
  else {
    const metricsData = records?.map((item: { [x: string]: any; }) => item?.[key]);
    for (let i = 0;i < metricsData?.length;i++) {
      const item = metricsData[i];

      if (item?.dod || item?.dod === '') {
        content += `${dateCol[i] || '-'  }\t${  item?.count || item?.value || '-'  }\t${  metricsData[i]?.dod || '-'  }\n`;
      } else if (item?.bubble) {
        content += `${dateCol[i] || '-'  }\t${  item?.cellContent || '-'  }\n`;
      } else {
        content += `${dateCol[i] || '-'  }\t${  item || '-'  }\n`;
      }
    }
  }
  return content;
};

const removeDodSdlwChangeHeader = (contentVal: any, formatMessage: any, timeType: string) => {
  const DOD_STR = `\t${  formatMessage({ id: dodKeyObj?.[timeType?.toLowerCase()] })  }\n`;
  const CHANGE_STR = `\t${  formatMessage({ id: 'change' })  }\n`;
  const SDLW_STR = `\t${  formatMessage({ id: sdlwKeyObj?.[timeType?.toLowerCase()] })  }\n`;
  const contentStr = contentVal;
  if (contentStr?.includes(DOD_STR)) {
    return `${contentStr?.split(DOD_STR)?.[0]  }\n`;
  }

  if (contentStr?.includes(SDLW_STR)) {
    return `${contentStr?.split(SDLW_STR)?.[0]  }\n`;
  }

  if (contentStr?.includes(CHANGE_STR)) {
    return `${contentStr?.split(CHANGE_STR)?.[0]  }\n`;
  }

  return contentStr;
};

const copyText = (text: any) => {
  const textarea = document.createElement("textarea");// 创建input对象
  const currentFocus = document.activeElement;// 当前获得焦点的元素
  let flag = false;
  document.body.appendChild(textarea);// 添加元素
  // 给表单赋值
  textarea.value = text;
  // 判断光标是否在第一位置
  textarea.focus();
  if (textarea.setSelectionRange)
    textarea.setSelectionRange(0, textarea.value.length);// 获取光标起始位置到结束位置
  else
    textarea.select();
  try {
    flag = document.execCommand("copy");// 执行复制
  } catch (eo) {
    flag = false;
  }
  document.body.removeChild(textarea);// 删除元素
  currentFocus?.focus();
  return flag;
};
